const CourseData=[
    {
        date:"Sat Dec 25 2021",
        title:"IIT Roorkee Free Online Certification Courses | Learn Digital Designing for Free",
        content :"Hey Students! We are back again with some free Workshops for you. This time if you are a designer and want to master your design skills on Autodesk then this post is for you. If you are a beginner even ",
        link:"/freeCourses/post0"
    },
    {
        date:"Tue Dec 21 2021",
        title:"Google Learn to Earn Cloud Security Challenge Bonus Level | Free Swags",
        content :"Hey Students! Yesterday we posted a blog related to Learn to Earn Cloud Security Challenge 2022 Bonus Level where we got an amazing response from you guys. But we are still left with the registration part. How does it work?",
        link:"/freeCourses/post1"
    },
    {
        date:"Thu Dec 23 2021",
        title:"Android Day on Google Open Source Live on 3rd and 4th Feb 2022: Register Now and Get Free Swags from Google",
        content :"Hey Students! Are you an Android enthusiast and looking for some open source events related to it? If yes the Android Day on Google Open Source are about to begin where you gain Google swag & live caricature face drawings!",
        link:"/freeCourses/post2"
    },
    {
        date:"Sun Dec 19 2021",
        title:"Google Maps Local guide Program For Indians | All Benefits & Rewards",
        content :"Hey Students! Here is the amazing news for everyone. In this post I will Guide you about the Google maps Local Guide Program i.e. specially for Indians regardless of degree & Education. What is the Google Local Guide program? Local",
        link:"/freeCourses/post3"
    }
]
export default CourseData;